module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "w footer-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-right"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer-item"
  }, [_c('div', {
    staticClass: "footer-item-title"
  }, [_vm._v("产品")]), _vm._v(" "), _vm._l((_vm.cateList), function(item) {
    return [_vm._l((item.children), function(childItem) {
      return [(childItem.category_id == 148) ? _c('div', {
        key: childItem.category_id,
        staticClass: "footer-item-text",
        on: {
          "click": function($event) {
            return _vm.goodsList(item, childItem)
          }
        }
      }, [_vm._v("客餐厅系列")]) : _vm._e(), _vm._v(" "), (childItem.category_id == 46) ? _c('div', {
        key: childItem.category_id,
        staticClass: "footer-item-text",
        on: {
          "click": function($event) {
            return _vm.goodsList(item, childItem)
          }
        }
      }, [_vm._v("卧室系列")]) : _vm._e(), _vm._v(" "), (childItem.category_id == 136) ? _c('div', {
        key: childItem.category_id,
        staticClass: "footer-item-text",
        on: {
          "click": function($event) {
            return _vm.goodsList(item, childItem)
          }
        }
      }, [_vm._v("全屋定制")]) : _vm._e()]
    })]
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])]), _vm._v(" "), _vm._m(6)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-left"
  }, [_c('img', {
    staticClass: "footer-logo",
    attrs: {
      "src": "/static/images/logo2.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {}, [_c('img', {
    staticClass: "footer-weixin",
    attrs: {
      "src": "/static/images/weixin.png",
      "alt": ""
    }
  }), _vm._v("\n        官方微信\n      ")]), _vm._v(" "), _c('div', {}, [_c('img', {
    staticClass: "footer-weixin",
    attrs: {
      "src": "/static/images/weibo.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "https://weibo.com/gujiajiaju",
      "target": "_blank"
    }
  }, [_vm._v("\n          官方微博\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item"
  }, [_c('div', {
    staticClass: "footer-item-title"
  }, [_vm._v("关于顾家")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/",
      "target": "_blank"
    }
  }, [_vm._v("官网首页")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/home/aboutUs?id=3",
      "target": "_blank"
    }
  }, [_vm._v("品牌历程")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/home/aboutUs?id=2",
      "target": "_blank"
    }
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/home/aboutUs?id=4",
      "target": "_blank"
    }
  }, [_vm._v("顾家荣耀")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item"
  }, [_c('div', {
    staticClass: "footer-item-title"
  }, [_vm._v("服务")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/home/service?id=1",
      "target": "_blank"
    }
  }, [_vm._v("服务政策")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/home/service?id=1",
      "target": "_blank"
    }
  }, [_vm._v("服务流程")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/home/service?id=1",
      "target": "_blank"
    }
  }, [_vm._v("服务规范")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item"
  }, [_c('div', {
    staticClass: "footer-item-title"
  }, [_vm._v("合作")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/home/cooperation?id=3",
      "target": "_blank"
    }
  }, [_vm._v("招标公告")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/home/cooperation?id=1",
      "target": "_blank"
    }
  }, [_vm._v("工程合作")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://gw.kukahome.com/join/index.html",
      "target": "_blank"
    }
  }, [_vm._v("商家入住")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item footer-item-border"
  }, [_c('div', {
    staticClass: "footer-item-title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "",
      "target": "_blank"
    }
  }, [_vm._v("客服热线")]), _vm._v(" "), _c('div', {
    staticClass: "footer-item-tel"
  }, [_vm._v("4006816816")]), _vm._v(" "), _c('div', {
    staticClass: "footer-item-time"
  }, [_vm._v("（8:30~20:00)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-item-right"
  }, [_c('div', {
    staticClass: "footer-code"
  }, [_c('img', {
    staticClass: "footer-code-img",
    attrs: {
      "src": "/static/images/weixin.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-code-text"
  }, [_vm._v("官方微信服务号")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-code"
  }, [_c('img', {
    staticClass: "footer-code-img",
    attrs: {
      "src": "/static/images/xcx.jpeg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-code-text"
  }, [_vm._v("官方小程序")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ipRecord"
  }, [_vm._v("\n   Copyright © "), _c('a', {
    staticClass: "footer-item-text",
    attrs: {
      "href": "https://beian.miit.gov.cn/",
      "target": "_blank"
    }
  }, [_vm._v("浙ICP备11025180号-1")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6ac844c2","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footer.vue
// module id = 692
// module chunks = 0 2 4 5 8 10 11 15 16 17 18 23 24